import React, { useState, useEffect, useCallback } from "react";
import { useParams } from "react-router-dom";
import { CancelRequest } from "../../../../services/AxiosInstance";
import { useNavigate } from "react-router-dom";
import Pagination from "../../../constant/Pagination";
import TableLoaderEffect from "../../../constant/TableLoader";
import DebounceSearchInput from "../../../constant/DebounceSearchInput";
import { getCircularListApi } from "../../../../services/DocumentService";
import VersionStatus from "./VersionStatus";
import AddCircularSheet from "./AddCircular";

const Circular = ({ SheetStatus }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [data, setData] = useState(null);
  const [query, setSearchQuery] = useState("");
  const [total, setTotal] = useState(0);
  const [showModal, setShowModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const recordsPage = 25;
  const { id } = useParams();
  const navigate = useNavigate();

  const fetchData = useCallback(() => {
    CancelRequest();
    setIsLoading(true);
    getCircularListApi(id)
      .then((resp) => {
        setData(resp.data.results);
        setTotal(resp.data.total);
      })
      .catch((error) => {
        console.error(error.response?.data?.message);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [id]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const handlePagination = (page) => {
    setCurrentPage(page.selected + 1);
  };

  const handleAfterCreate = () => {
    setCurrentPage(1);
    fetchData();
  };

  const handleAfterUpdate = (updatedData) => {
    setData((prevData) =>
      prevData.map((item) =>
        item.id === updatedData.id ? { ...item, ...updatedData } : item
      )
    );
  };

  return (
    <div className="row">
      <div className="col-xl-12">
        <div className="card">
          <div className="card-body p-0">
            <div className="table-header">
              <h4 className="mb-0 ms-2">Circular</h4>
              <div className="table-left-header">
                <div className="form-group me-3">
                  <DebounceSearchInput
                    value={query}
                    onChange={(e) => setSearchQuery(e.target.value)}
                  />
                </div>

                {SheetStatus === "issued" && (
                  <>
                    <button
                      className="btn btn-primary"
                      onClick={() => setShowModal(true)}
                    >
                      Add Circular
                    </button>

                    <AddCircularSheet
                      show={showModal}
                      onHide={() => setShowModal(false)}
                      id={id}
                      handleAfterCreate={handleAfterCreate}
                    />
                  </>
                )}
              </div>
            </div>
            {data?.length > 0 ? (
              <div className="table-responsive active-projects style-1 ItemsCheckboxSec shorting">
                <table
                  id="employees-tblwrapper"
                  className="table ItemsCheckboxSec dataTable no-footer mb-0"
                >
                  <thead>
                    <tr>
                      <th>Title</th>
                      <th>Created By</th>
                      <th>Approved By</th>
                      <th>Tested By</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {isLoading ? (
                      <TableLoaderEffect colLength={6} />
                    ) : (
                      data.map((item, index) => (
                        <tr key={index}>
                          <td>
                            <span
                              className="fw-bold text-primary c-pointer"
                              onClick={() =>
                                navigate(`/circular/${item.id}`, {
                                  state: { id },
                                })
                              }
                            >
                              {item?.title}
                            </span>
                          </td>
                          <td>
                            <div className="d-flex flex-column">
                              <strong>{item?.created_by?.name}</strong>
                              <span>{item?.created_by?.created_at}</span>
                            </div>
                          </td>
                          <td>
                            <div className="d-flex flex-column">
                              <strong>{item?.approved_by?.name}</strong>
                              <span>{item?.approved_by?.approved_at}</span>
                            </div>
                          </td>
                          <td>
                            <div className="d-flex flex-column">
                              <strong>{item?.tested_by?.name}</strong>
                            </div>
                          </td>
                          <td>
                            <VersionStatus
                              data={item}
                              handleAfterUpdate={handleAfterUpdate}
                            />
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
            ) : (
              <div className="card">
                <div className="card-body">
                  <h4 className="text-center text-danger">
                    ⚠️ No Circular Found
                  </h4>
                </div>
              </div>
            )}

            {!isLoading && total > 0 && (
              <Pagination
                currentPage={currentPage}
                recordsPage={recordsPage}
                dataLength={total}
                handlePagination={handlePagination}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Circular;
